import { useState } from "react";

// Generalizes CustodialView's clock in/out state machine (captureClockPhoto
// + the Time Card tab's button block in Portal/TimeCardTab). A worker is
// either clocked in (openEntry is set) or not; both transitions require a
// photo. Callers supply onClockIn/onClockOut, which receive the captured
// File and do whatever persistence makes sense for their entity (a
// TimeCardEntry against a Worker here, vs. a timeEntries doc under a
// client in CustodialView) — this component has no opinion on that.
export default function ClockInOut({ openEntry, onClockIn, onClockOut, labels = {} }) {
  const L = {
    clockIn: "Clock In — Photo Front Door",
    clockOut: "Clock Out — Photo Front Door",
    clockedInAt: (d) => `Clocked in ${d}`,
    ...labels,
  };
  const [uploading, setUploading] = useState(false);
  const [err, setErr] = useState("");

  const capture = (onFile) => {
    const input = document.createElement("input");
    input.type = "file"; input.accept = "image/*"; input.capture = "environment";
    input.onchange = async (e) => {
      const file = e.target.files[0]; if (!file) return;
      setUploading(true); setErr("");
      try { await onFile(file); }
      catch (e) { setErr("Upload failed — check connection and try again"); }
      setUploading(false);
    };
    input.click();
  };

  return (
    <div style={{ background:"#fff", borderRadius:"12px", border:"1px solid #E2E8F0", padding:"18px", textAlign:"center" }}>
      {err && <div style={{ color:"#DC2626", fontSize:"13px", marginBottom:"10px" }}>{err}</div>}
      {openEntry ? (
        <>
          <div style={{ fontSize:"12px", color:"#64748B", marginBottom:"10px" }}>{L.clockedInAt(openEntry.clockInLabel || "")}</div>
          <button onClick={()=>capture(onClockOut)} disabled={uploading}
            style={{ width:"100%", padding:"18px 0", background: uploading ? "#94A3B8" : "#DC2626", color:"#fff", border:"none", borderRadius:"12px", fontSize:"16px", fontWeight:"700", cursor:"pointer" }}>
            {uploading ? "Uploading…" : L.clockOut}
          </button>
        </>
      ) : (
        <button onClick={()=>capture(onClockIn)} disabled={uploading}
          style={{ width:"100%", padding:"18px 0", background: uploading ? "#94A3B8" : "#16A34A", color:"#fff", border:"none", borderRadius:"12px", fontSize:"16px", fontWeight:"700", cursor:"pointer" }}>
          {uploading ? "Uploading…" : L.clockIn}
        </button>
      )}
    </div>
  );
}
